import React, { Component } from "react";
import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import firebase, { firestore } from "firebase";
import moment from "moment/moment";

import { updateGame } from "../../actions/index";
// import { GameTypeChoice } from "./GameTypeChoice";
import {EventHuntChoice, saturdayAtNoon} from "./EventHuntChoice";
import {
    // GAME_TYPE, EVENT_DATE, RANDOM_CLUES, GAME_TYPE_CODE
    EVENT_DATE
} from "../../constants/Game";

import './UpdateIntro.css'
import "../../global.css"

/**
 * Goes inside a modal to update just the location name/description.
 */
class UpdateGameType extends Component {
    constructor(props) {
        super(props);

        // const gameType = props.game ? props.game[GAME_TYPE] : null;
        let dateValue = props.game ? props.game[EVENT_DATE] : null;
        // const randomClueOrder = props.game ? props.game[RANDOM_CLUES] : false;

        // workaround for allowing nulls
        if (dateValue === undefined) dateValue = null;

        this.state = {
            // gameType,
            dateValue,
            // randomClueOrder,
            isFetching: false
        };

        // this.onGameTypeChange = this.onGameTypeChange.bind(this);
        this.onEventHuntChecked = this.onEventHuntChecked.bind(this);
        // this.onRandomClueOrderChecked = this.onRandomClueOrderChecked.bind(this);
        this.onEventHuntDateChange = this.onEventHuntDateChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    // onGameTypeChange(event, newValue) {
    //
    //     this.setState( { gameType: newValue });
    // }

   onEventHuntChecked(event, newValue) {
      if (newValue) {
         this.setState({dateValue: firebase.firestore.Timestamp.fromDate(saturdayAtNoon())})
      } else {
         this.setState({dateValue: null})
      }
   }

    onEventHuntDateChange(value) {
       if (!!value) {
            this.setState( { dateValue: firestore.Timestamp.fromDate(moment(value).toDate()) });
        } else {
            this.setState( { dateValue: null })
        }
    }

    // onRandomClueOrderChecked(event, value) {
    //     this.setState( { randomClueOrder: value })
    // }

    onSubmit(values) {

        this.setState( { isFetching: true });

        const { game, closeModalCallback } = this.props;

        values[EVENT_DATE] = this.state.dateValue;
        // values[RANDOM_CLUES] = !!this.state.randomClueOrder && this.state.gameType === GAME_TYPE_CODE;

        this.props.updateGame(game.id, game.isPublic, values, () => {

            closeModalCallback();
        });
    }

    render() {
        const { handleSubmit } = this.props;

        const noTopPadding = {
            paddingTop: '0px'
        };

        // onDateChange, onEventHuntChecked, dateValue

        return (
            <div>
                <button
                    style={noTopPadding}
                    className="btn btn-link pull-right"
                    onClick={this.props.closeModalCallback}>

                    X
                </button>
                <h4 className="location-update-dialog-buffer bottom-margin"> Update Hunt Game Type </h4>
                <p> Change whether or not this hunt is
                    an event hunt, and, if so, the exact tine the event hunt will start.
                </p>

                <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                    <div>
                    <div className="col-9">
                        {/*<GameTypeChoice*/}
                        {/*    isShort={true}*/}
                        {/*    gameType={this.state.gameType}*/}
                        {/*    onChange={this.onGameTypeChange}*/}
                        {/*    randomClueOrder={this.state.randomClueOrder}*/}
                        {/*    onRandomClueOrderChecked={this.onRandomClueOrderChecked}*/}
                        {/*/>*/}
                        <EventHuntChoice
                            dateValue={this.state.dateValue}
                            onEventHuntChecked={this.onEventHuntChecked}
                            onDateChange={this.onEventHuntDateChange}
                        />
                    </div>
                    <button type="submit">
                        Save
                    </button>
                  </div>
                </form>

                {this.state.isFetching && <div className="loader"/>}
            </div>
        )
    }
}

// Decorate with reduxForm(). It will read the initialValues prop provided by connect()
UpdateGameType = reduxForm({
    form: 'UpdateGameTypeForm' // a unique identifier for this form
})(
    connect(null, { updateGame }
    )(UpdateGameType));

// You have to connect() to any reducers that you wish to connect to yourself

UpdateGameType = connect(
    state => {
        const selectedGame = state.games[state.selectedGameId];

        return {
            game: selectedGame
        }
    }
)(UpdateGameType);

export default UpdateGameType;



// WEBPACK FOOTER //
// ./src/components/huntcomponents/UpdateGameType.js